import { render, staticRenderFns } from "./ModalLoading.vue?vue&type=template&id=324fb0a3&scoped=true"
import script from "./ModalLoading.vue?vue&type=script&lang=js"
export * from "./ModalLoading.vue?vue&type=script&lang=js"
import style0 from "./ModalLoading.vue?vue&type=style&index=0&id=324fb0a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324fb0a3",
  null
  
)

export default component.exports